import { z } from "zod";
import { BusinessType } from "./BusinessType";
import { BusinessModelSchema } from "./BusinessModel";
import { AddressModelSchema } from "./AddressModel";

export const BusinessDetailsModelSchema = z.object({
  businessType: z.nativeEnum(BusinessType).nullable(),
  fuelCardBusinessUseOnly: z.boolean().nullable(),
  business: BusinessModelSchema.nullable(),
  businessName: z.string().nullable(),
  hasManualInputBusiness: z.boolean().nullable(),
  hasDifferentTradingName: z.boolean().nullable(),
  tradingName: z.string().nullable(),
  physicalAddress: AddressModelSchema.nullable(),
  physicalAddressText: z.string().nullable(),
  hasManualPhysicalAddress: z.boolean().nullable(),
  fuelAmount: z.number().nullable(),
  businessNameComplete: z.boolean().nullable(),
  physicalAddressComplete: z.boolean().nullable(),
  sectionComplete: z.boolean().nullable(),
});
